export class AbmTable<R, C, V>{
    private table: Map<R, Map<C, V>> = new Map();

    public set(row: R, column: C, value: V): V {
        const oldRow = this.table.get(row);
        let oldValue: V;
        if (oldRow) {
            oldValue = oldRow.get(column);
            oldRow.set(column, value);
        } else {
            const newRow: Map<C, V> = new Map();
            newRow.set(column, value);
            this.table.set(row, newRow);
        }
        return oldValue;
    }

    public get(row: R, column: C): V {
        const dataRow = this.table.get(row);
        if (dataRow) {
            return dataRow.get(column);
        } else {
            return undefined;
        }
    }

    public setRow(row: R, columns: Map<C, V>): Map<C, V> {
        const oldRow = this.table.get(row);
        this.table.set(row, columns);
        return oldRow;
    }

    public getRow(row: R): Map<C, V> {
        return this.table.get(row);
    }

    public rowKeys() {
        return this.table.keys();
    }

    public values(): V[] {
        const values: V[] = [];
        this.table.forEach(value => { value.forEach(v => values.push(v)); });
        return values;
    }
}
